export default __webpack_public_path__ + "static/media/table_Cn.e62a675c.webp";